export default __webpack_public_path__ + "static/media/white-inabit.2f32546e.svg";